import '../../Components/Page/Page.css'
import SecHeader from '../../Components/SecHeader/SecHeader';
import '../../Content/Software/Software.css';


const DeRisking: React.FC = () => {
    return (
        <div className='software'>
            <SecHeader title="De-Risking" />
            <div className="description">
                <p>
                    <div>
                        <b>Tariff-Proofing​</b>
                        <br />• ICE GEMS is “Tariff – Proof”  since we encourage producing 
                        new engines and parts in all countries
                        <br />• We are U.S. made, owned, and IP-controlled, with 100% 
                        in-house product production
                        <br/>
                    </div>
                    <div>
                        <b>Policy-Proofing​</b>
                        <br />• ICE GEMS is “Policy – Proof”  since ELF-Tech improves energy 
                        resilience, jobs, environmental impacts, climates, manufacturing, tech 
                        leadership, and public Policies 
                        <br />
                    </div>
                    <div>
                        <b>Future-Proofing​</b>
                        <br />• ELF-Tech engines can (a) uses exiting fuels more cleanly and 
                        efficiently, and (b) be used to retrofit exiting vehicles, saving jobs 
                        and factories, so we comply with short term policies
                        ​<br />• As new Net-0-CO2 fuels come,       ELF-Tech offers the best ways 
                        to improve environmental impacts, climates, and jobs, so ICE GEMS is 
                        “Future-Proof”         for the next 50 years
                        ​<br />
                    </div>
                </p>
            </div>
        </div>
    );
};

export default DeRisking;